import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";

import { AD_LAYOUT_STUBS } from "@consts";
import { getDateDataFromDateCode, newsArticleSchema } from "@utils";

dayjs.extend(utc);
dayjs.extend(tz);

export default {
	name: "Contexto",
	data() {
		return {
			AD_LAYOUT_STUBS,
			showAnswer: false,
			todayData: null,
			pastData: [],
			tableHeaders: ["Date", "Contexto Puzzle", "Contexto Answer"],
		};
	},
	// asyncData: STRICTLY the cache-expiry header. It is the only hook with
	// access to `res`, which is the sole reason it still exists here.
	asyncData({ res }) {
		if (!res) {
			return;
		}

		const now = dayjs().tz("America/New_York");
		let nextRefreshDate = dayjs().utc().hour(0).minute(0).startOf("minute");
		if (nextRefreshDate.isBefore(now)) {
			// Same time tomorrow
			nextRefreshDate = nextRefreshDate.add(1, "day");
		}

		res.setHeader(
			"Expires",
			nextRefreshDate.utc().format("ddd, DD MMM YYYY HH:mm:ss [GMT]")
		);
	},
	// fetch: content loading (SSR + client nav). Non-blocking on the client, so
	// navigating here no longer freezes the route transition.
	async fetch() {
		await this.loadData();
	},
	head() {
		const today = getDateDataFromDateCode(this.todayData?.date);
		const metaTitle = this.$t(this.$route.meta.title, {
			MonthDay: `${today.month} ${today.day}`,
		});
		return {
			title: metaTitle,
			script: [
				newsArticleSchema({
					headline: metaTitle,
					image: "https://wordfinder.yourdictionary.com/static/images/contexto-og.jpg",
					datePublished: "2022-12-20T08:00:00.000Z",
				}),
			],
		};
	},
	computed: {
		answerHeading() {
			if (!this.todayData) {
				return null;
			}

			const strings = [
				`Today's Contexto Answer (#${this.todayData.index})`,
				this.dateString,
			];

			return strings.join(this.isSmallDevice ? "<br />" : " - ");
		},
		dateString() {
			const date = getDateDataFromDateCode(this.todayData.date);
			return `${date.month} ${date.day}, ${date.year}`;
		},
		pastAnswers() {
			if (!Array.isArray(this.pastData) || !this.pastData.length) {
				return [];
			}

			return this.pastData.map((group) => {
				const o = {};
				const monthDate = getDateDataFromDateCode(
					group.month,
					this.isSmallDevice
				);
				o.headerText = monthDate?.formatted;
				o.headerId = `answers-${monthDate.month}-${monthDate.year}`;

				o.rows = group.answers.map((answer) => ({
					date: getDateDataFromDateCode(
						answer.date,
						this.isSmallDevice
					)?.formatted,
					index: answer.index,
					answer: answer.answer,
				}));

				return o;
			});
		},
	},
	methods: {
		async loadData() {
			const serviceResponse = await this.$axios
				.get(`${this.$config.API_SERVICE}/v4/contexto`)
				.then((response) =>
					response.status === 200 && response.data.status === 200
						? response.data
						: {}
				)
				.catch((err) => {
					console.error(
						"Could not connect to Contexto API endpoint",
						err
					);
					return {};
				});

			this.todayData = serviceResponse?.today || null;
			this.pastData = serviceResponse?.past || [];
		},
	},
};
